import React, { useEffect } from 'react'
import styled from 'styled-components'
import OfficeMultiSelect from '../../General/Office/OfficeMultiSelect'
import { useArticleDataState } from '../../../stores/Configuration/ArticleDataProvider'
import { Spinner } from 'react-bootstrap'

const StyledWrapper = styled.div`
  @media screen and (min-width: 1080px) {
    max-width: calc(100% - 480px);
    min-width: 600px;
  }
  .search-wrapper{
    padding-left: 0;
    padding-right: 0;
  }
  .action-buttons {
    visibility: visible !important;
  }
`
const ArticleOfficeAvailabilities = ({ selectedOffices, setSelectedOffices, loadingStates }) => {
  const { initArticleOfficeAvailabilities } = useArticleDataState()

  useEffect(() => {
    initArticleOfficeAvailabilities()
  }, [initArticleOfficeAvailabilities])

  if (loadingStates.getArticleOfficeAvailabilities) {
    return <div className="d-flex align-items-center justify-content-center"><Spinner animation='border' variant='primary' /></div>
  }
  return (
    <>
      <div className="d-flex align-items-center additional">
        <StyledWrapper>
          <OfficeMultiSelect selectedOfficeIds={selectedOffices} setSelectedOfficeIds={setSelectedOffices} />
        </StyledWrapper>
      </div>
    </>
  )
}

export default ArticleOfficeAvailabilities